export default "__VITE_ASSET__D1g4KfVu__"